import React from "react";
import { Steps, Button } from "antd";
import StepsWizardWrapper from "./StepsWizard.style";
import { CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Step } = Steps;

const StepsWizard = (props) => {
  const {
    steps,
    onChangeSlide,
    current,
    onMouseOver,
    onMouseOut,
    handleCancel,
  } = props;

  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const items = steps.map((step, i) => ({
    key: i,
    title: step.title,
  }));
  return (
    <StepsWizardWrapper direction={currentAppLocale.direction}>
      <div className="steps" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={handleCancel}
        />
        {steps && steps.length > 1 ? (
          <Steps
            size="small"
            current={current}
            onChange={onChangeSlide}
            items={items}
          />
        ) : null}
      </div>
      <div className="inner">{steps[current].comp}</div>
    </StepsWizardWrapper>
  );
};

export default StepsWizard;
